module.exports = __webpack_public_path__ + "img/ar_ttl_shop_bl.1f7a6079.svg";